import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function CrearOrdenPaypal_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "CrearOrdenPaypal",
    rutaEndPoint: "/crearordenpaypal",
    sistemaOrigen: "Web",
    AGREGAR_ENCABEZADO: false,
    DESTINO_SERVICIO: DestinoConexion.BackendSelfService,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA


export interface EBMHeaderRequest {
    Operacion: string;
    SistemaOrigen: string;
}

export function builtEBMHeaderRequest(p_operacion: string, p_sistemaOrigen: string) {
    var retorno: EBMHeaderRequest ={
        Operacion: p_operacion,
        SistemaOrigen: p_sistemaOrigen
  };
  return retorno;
}
export interface DatosSKY {
    NumeroCuenta: string;
}

export function builtDatosSKY(p_numeroCuenta: string) {
    var retorno: DatosSKY ={
        NumeroCuenta: p_numeroCuenta
  };
  return retorno;
}


export interface Monto {
    CodigoMoneda: string;
    Valor:        string;
}

export function builtMonto(p_codigoMoneda: string, p_valor: string) {
    var retorno: Monto ={
        CodigoMoneda: p_codigoMoneda,
        Valor: p_valor
  };
  return retorno;
}


export interface Articulo {
    Nombre:        string;
    Cantidad:      string;
    Descripcion:   string;
    MontoUnitario: Monto;
}


export function builtArticulo(p_nombre: string, p_cantidad: string, p_descripcion: string, p_montoUnitario: Monto ) {
    var retorno: Articulo ={
        Nombre:        p_nombre,
        Cantidad:      p_cantidad,
        Descripcion:   p_descripcion,
        MontoUnitario: p_montoUnitario
  };
  return retorno;
}


export interface Desglose {
    Total: Monto;
}

export function builtDesglose(p_total: Monto) {
    var retorno: Desglose ={
        Total: p_total
  };
  return retorno;
}


export interface ComprarUnidadeMonto {
    Monto:    Monto;
    Desglose: Desglose;
}

export function builtComprarUnidadeMonto(p_monto: Monto, p_desglose: Desglose) {
    var retorno: ComprarUnidadeMonto ={
        Monto:     p_monto,
        Desglose : p_desglose
  };
  return retorno;
}


export interface ComprarUnidade {
    ReferenciaId: string;
    CustomId: string;
    Articulos:    Articulo[];
    Monto:        ComprarUnidadeMonto;
}

export function builtComprarUnidade(p_referenciaId:string ,p_customId:string, p_articulos: Articulo[], p_monto: ComprarUnidadeMonto) {
    var retorno: ComprarUnidade ={
        ReferenciaId:  p_referenciaId,
        CustomId:      p_customId,
        Articulos:     p_articulos,
        Monto:         p_monto
  };
  return retorno;
}


export interface ContextoAplicacion {
    ReturnURL: string;
    CancelURL: string;
}

export function builtContextoAplicacion(p_returnURL: string, p_cancelURL: string) {
    var retorno: ContextoAplicacion ={
        ReturnURL:  p_returnURL,
        CancelURL:  p_cancelURL
  };
  return retorno;
}


export interface Orden {
    DatosSKY:           DatosSKY;
    Intento:            string;
    ComprarUnidades:    ComprarUnidade[];
    ContextoAplicacion: ContextoAplicacion;
}

export function builtOrden(p_datosSKY: DatosSKY, p_intento: string, p_comprarUnidades: ComprarUnidade[], p_contextoAplicacion: ContextoAplicacion) {
  var retorno: Orden ={
        DatosSKY:           p_datosSKY,
        Intento:            p_intento,
        ComprarUnidades:    p_comprarUnidades,
        ContextoAplicacion: p_contextoAplicacion
  };
  return retorno;
}


export interface CrearOrdenPaypal_Entrada {
    EBMHeaderRequest:EBMHeaderRequest,
    Orden: Orden;
}

export function builtCrearOrdenPaypalEntrada(p_orden: Orden, p_ebmHeaderRequest: EBMHeaderRequest) {
    var retorno: CrearOrdenPaypal_Entrada ={
        EBMHeaderRequest: p_ebmHeaderRequest,
        Orden:  p_orden
  };
  return retorno;
}



//SALIDA
export interface CrearOrdenPaypal_Salida {
     Orden:             OrdenSalida;
}

// export interface CrearOrdenPaypal_Salida {
//     EBMHeaderResponse: EBMHeaderResponse;
//     Orden:             Orden;
// }

// export interface EBMHeaderResponse {
//     ErrorTecnico: ErrorTecnico;
//     ErrorNegocio: ErrorNegocio;
// }

// export interface ErrorNegocio {
//     Estado:           string;
//     CodigoError:      string;
//     DescripcionError: string;
// }

// export interface ErrorTecnico {
//     code:    string;
//     Sistema: string;
// }

export interface OrdenSalida {
    FechaCreacion:   Date;
    Id:              string;
    DatosSKY:        DatosSKY;
    Intento:         string;
    Estatus:         string;
    ComprarUnidades: ComprarUnidadeSalida[];
    Links:           Link[];
}

export interface ComprarUnidadeSalida {
    ReferenciaId: string;
    Articulos:    Articulo[];
    Monto:        ComprarUnidadeMonto;
    Beneficiario: Beneficiario;
}

export interface Beneficiario {
    Email:         string;
    IdComerciante: string;
}

export interface Link {
    Href:     string;
    Relacion: string;
    Metodo:   string;
}


export type CrearOrdenPaypal_Respuesta = EncabezadoRespuestaInterna & CrearOrdenPaypal_Salida;